import ValidateDocumentMocks from './domain/Account/Client/Mocks/ValidateDocumentMocks';
import ValidateEmailRegisterMocks from './domain/Account/Client/Mocks/ValidateEmailRegisterMocks';
import GenerateTokenSmsMocks from './domain/Account/Client/Mocks/GenerateTokenSmsMocks';
import ValidateTokenSmsMocks from './domain/Account/Client/Mocks/ValidateTokenSmsMocks';
import GenerateTokenEmailMocks from './domain/Account/Client/Mocks/GenerateTokenEmailMocks';
import ValidateTokenEmailMocks from './domain/Account/Client/Mocks/ValidateTokenEmailMocks';
import RecoverMemberNumberMocks from './domain/Account/Client/Mocks/RecoverMemberNumberMocks';
import CountriesMocks from './domain/Account/Client/Mocks/CountriesMocks';
import ZipCodeMocks from './domain/Account/Client/Mocks/ZipCodeMocks';
import CreateMemberMocks from './domain/Account/Client/Mocks/CreateMemberMocks';
import ChangePasswordMocks from './domain/Account/Client/Mocks/ChangePasswordMocks';
import RecoverBigDataQuestionMocks from './domain/Account/Client/Mocks/RecoverBigDataQuestionMocks';
import ValidateBigDataQuestionMocks from './domain/Account/Client/Mocks/ValidateBigDataQuestionMocks';
import MemberInfoMocks from './domain/Account/Client/Mocks/MemberInfoMocks';
import MaskedContactMocks from './domain/Account/Client/Mocks/MaskedContactMocks';
import AccountIssueMocks from './domain/Account/Client/Mocks/AccountIssueMocks';
import ResetPasswordAccountIssueMocks from './domain/Account/Client/Mocks/ResetPasswordAccountIssueMocks';
import ResetPasswordMocks from './domain/Account/Client/Mocks/ResetPasswordMocks';
import { IMockProps } from './types';
import AccountStatusMocks from './domain/Account/Client/Mocks/MemberStatusMocks';
import UpdateMemberMocks from './domain/Account/Client/Mocks/UpdateMemberMocks';
import UpdateMemberSensitiveDataMocks from './domain/Account/Client/Mocks/UpdateMemberSensitiveDataMocks';
import GetMemberMocks from './domain/Account/Client/Mocks/GetMemberMocks';
import ValidateLegalGuardianMocks from './domain/Account/Client/Mocks/ValidateLegalGuardianMocks';
import GetDependentsMocks from './domain/Account/Client/Mocks/GetDependentsMocks';
import SendTokenEmail from './domain/Account/Client/Mocks/SendTokenEmailMocks';
import PartnerTokenMocks from './domain/Utils/Partners/Mocks/PartnerTokenMocks';
import GetGeoLocationMocks from './domain/Utils/Geolocation/Mocks/GetGeoLocationMocks';
import GetHeadlessDeliveryMocks from './domain/Utils/Cms/Mocks/GetHeadlessDeliveryMocks';
import CheckUpdateMemberStatusMocks from './domain/Account/Client/Mocks/CheckUpdateMemberStatusMock';

const Mocks: IMockProps[] = [
  ...CheckUpdateMemberStatusMocks,
  ...ValidateDocumentMocks,
  ...ValidateEmailRegisterMocks,
  ...GenerateTokenSmsMocks,
  ...ValidateTokenSmsMocks,
  ...GenerateTokenEmailMocks,
  ...ValidateTokenEmailMocks,
  ...RecoverMemberNumberMocks,
  ...CountriesMocks,
  ...ZipCodeMocks,
  ...CreateMemberMocks,
  ...ChangePasswordMocks,
  ...RecoverBigDataQuestionMocks,
  ...ValidateBigDataQuestionMocks,
  ...MemberInfoMocks,
  ...MaskedContactMocks,
  ...AccountIssueMocks,
  ...ResetPasswordAccountIssueMocks,
  ...ResetPasswordMocks,
  ...AccountStatusMocks,
  ...UpdateMemberMocks,
  ...UpdateMemberSensitiveDataMocks,
  ...GetMemberMocks,
  ...ValidateLegalGuardianMocks,
  ...GetDependentsMocks,
  ...SendTokenEmail,
  ...PartnerTokenMocks,
  ...GetGeoLocationMocks,
  ...GetHeadlessDeliveryMocks,
];

export default Mocks;
